/**
 * The build this page came from: a release version (major.minor.patch), a pull-request preview
 * (e.g. 1.0.4-pr.12) or a local development build (e.g. 1.0.0-dev). Set by vite.config.ts.
 */
export const APP_VERSION: string =
  typeof __PAWNED_VERSION__ === 'string' ? __PAWNED_VERSION__ : 'dev';
export const APP_COMMIT: string =
  typeof __PAWNED_COMMIT__ === 'string' ? __PAWNED_COMMIT__ : 'unknown';
export const APP_BUILT_AT: string =
  typeof __PAWNED_BUILT_AT__ === 'string' ? __PAWNED_BUILT_AT__ : '';

/** The first seven characters of the commit, as git shows them. */
export const APP_COMMIT_SHORT = APP_COMMIT.slice(0, 7);
